"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var React=require("react");function t(){let[e,r]=React.useState(null);return{anchorEl:e,handleClose:()=>r(null),toggle:e=>r(e.currentTarget)}}exports.default=t;
//# sourceMappingURL=useAnchorState.js.map
